import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { completedAnnotationsAtom } from '../atoms/annotation-review-atoms';
import { commentsAtom } from '../atoms/feedback-atoms';
import type { CompletedAnnotationT, ReviewOutputDataT } from '../types';
type Props = {
  reviewOutput?: ReviewOutputDataT;
};
export const useHydrateReviewAtoms = ({
  reviewOutput
}: Props) => {
  const setComments = useSetAtom(commentsAtom);
  const setCompletedAnnotations = useSetAtom(completedAnnotationsAtom);
  useEffect(() => {
    if (!reviewOutput) {
      return;
    }

    // Hydrate comments atom
    if (reviewOutput.comments) {
      setComments(reviewOutput.comments);
    }

    // Hydrate completed annotations atom
    if (reviewOutput.annotations) {
      const completedAnnotations: CompletedAnnotationT[] = reviewOutput.annotations.map(({
        annotationId,
        status
      }) => ({
        annotationId,
        status
      }));
      setCompletedAnnotations(() => completedAnnotations);
    }
  }, [reviewOutput, setComments, setCompletedAnnotations]);
};